import { useState } from "react";
import {
  useHistory,
  useLocation
} from "react-router-dom/cjs/react-router-dom.min";

import Button from "components/_parts/atoms/button";
import IconCustom from "components/_parts/atoms/icon";
import PopUp from "components/_parts/atoms/popUp";
import { useTranslation } from "react-i18next";

function DropdownCustom(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const handleShows = () => {
    setHideShowExport(!hideShowExport);
  };

  const [hideShowExport, setHideShowExport] = useState(false);

  const handlePopUp = value => {
    if (props?.type === "create") {
      if (props?.setTypeModal && props?.setModal !== undefined) {
        props?.setTypeModal(value.id);
        history.push("?tab=" + "0", {
          ...location.state
        });
        props?.setModal(prev => ({
          ...prev,
          create: true
        }));
      } else {
        props?.handleCreate(value);
      }
    } else if (props?.type === "create_child") {
      props?.handleChild(props?.childData, value);
    } else if (props?.type === "export") {
      props?.handleExport(value);
    } else if (props?.type === "move") {
      props?.handleMove(props?.moveData, value);
    } else if (props?.type === "option") {
      props?.handleShow(props.row, value);
    } else if (props?.type === "matrix") {
      value.func();
    }
    setHideShowExport(!hideShowExport);
  };

  const handleLastItem = value => {
    if (props?.type === "create") {
      if (props?.setTypeModal && props?.setModal !== undefined) {
        props?.setTypeModal(value?.id);
        props?.setModal(prev => ({
          ...prev,
          create: true
        }));
      } else {
        props?.handleCreate(value);
      }
    } else if (props?.type === "export") {
      props?.handleImport();
    } else if (props?.type === "option") {
      props?.handleDelete();
    }
    setHideShowExport(!hideShowExport);
  };

  return (
    <div
      className="dropdown_container"
      style={{ ...props?.style, maxWidth: "98px" }}
    >
      {props?.type === "create" ? (
        <Button
          icon="create"
          style={{
            userSelect: "none",
            height: "37px"
          }}
          func={handleShows}
        >
          {t("board.add")}
        </Button>
      ) : props?.type === "create_child" ? (
        <Button
          style={{
            userSelect: "none",
            height: "26px",
            width: "60px",
            backgroundColor: "#FFF",
            border: "2px solid #D9D9D9"
          }}
          func={handleShows}
        >
          <IconCustom
            typeIcon="plus"
            style={{ color: "#8A8A8A", strokeWidth: "4" }}
          />
          <IconCustom
            typeIcon="down"
            style={{ color: "#BCBCBC", marginLeft: "3px" }}
          />
        </Button>
      ) : props?.type === "move" ? (
        <Button
          style={{
            userSelect: "none",
            height: "26px",
            width: "60px",
            backgroundColor: "#FFF",
            border: "2px solid #D9D9D9"
          }}
          func={handleShows}
        >
          <IconCustom
            typeIcon="move"
            style={{ width: "12px", color: "#8A8A8A" }}
          />
          <IconCustom
            typeIcon="down"
            style={{ color: "#BCBCBC", marginLeft: "3px" }}
          />
        </Button>
      ) : props?.type === "option" ? (
        <Button
          style={{
            userSelect: "none",
            height: "26px",
            width: "60px",
            backgroundColor: "#FFF"
          }}
          func={handleShows}
        >
          <IconCustom typeIcon="option" style={{ color: "#8A8A8A" }} />
        </Button>
      ) : props?.type === "export" || props?.type === "import" ? (
        <Button
          style={{
            userSelect: "none",
            height: "26px",
            width: "60px",
            backgroundColor: "#FFF"
          }}
          func={handleShows}
        >
          <IconCustom typeIcon="setting" style={{ color: "#8A8A8A" }} />
        </Button>
      ) : props?.type === "matrix" ? (
        <Button
          style={{
            userSelect: "none",
            backgroundColor: "#FFF"
          }}
          func={handleShows}
        >
          <IconCustom
            typeIcon="setting"
            style={{ color: "#8A8A8A", width: "23px", height: "23px" }}
          />
        </Button>
      ) : (
        <div>
          belum ada type
          {props?.type}
        </div>
      )}

      <PopUp
        isHide={hideShowExport}
        setIsHide={setHideShowExport}
        datas={props?.datas}
        lastItem={props?.lastItem}
        position={props?.position}
        className={props.styleOption}
        setModal={props?.setModal}
        setTypeModal={props?.setTypeModal}
        handlePopUp={handlePopUp}
        handleLastItem={handleLastItem}
      />
    </div>
  );
}

export default DropdownCustom;
